export class OrdenCompras {
  public ord_tipo: string;
  public ord_tipoReporte: string;
  public ord_numorden: string;
  public ord_codbodega: string;
  public ord_codproveedor: string;
  public ord_codempresa: string;
  public ord_nomproveedor: string;
  public ord_codalmacen: string;
  public ord_fechaIni: string;
  public ord_fechaFin: string;
  public ord_idPedido: string;
  public ord_descarga: string;
  
  codError: any;
  root: any;
  msgError: any;
  success: any;


  constructor(

  ) { }
}




